import { useState } from "react";
import styled from "styled-components";

import COLORS from "components/atoms/colors";
import { TextXs } from "components/atoms/text";
import InputText from "components/atoms/input/Text";
import Btn from "components/atoms/buttons";
import ModalGuideMobile from "components/organisms/ModalGuideMobile";

import useCheckMobile from "hooks/useCheckMobile";
import useCreateProject from "apis/mutations/project/useCreateProject";

import imgAdd from "assets/images/common/add.svg";

interface Props {
  onVisibleMessage: () => void;
}

// 프로젝트 생성
const ItemCreate = ({ onVisibleMessage }: Props) => {
  const [show, setShow] = useState(false);
  const [name, setName] = useState("");

  const isMobile = useCheckMobile();

  // 프로젝트 생성 api
  const createProject = useCreateProject({
    onSuccess: () => setName(""),
  });

  // 프로젝트 생성 이벤트
  const handleCreateProject = () => {
    if (!name) return;
    createProject({ name });
  };

  // 프로젝트 입력폼 보이기 이벤트
  const handleClickShow = () => {
    setShow((prev) => !prev);
    onVisibleMessage();
  };

  return (
    <Container>
      {/* 모바일 디바이스의 경우 이용제한 모달 띄우기 => 기획변경으로 사용하지 않음 */}
      {/* <ModalGuideMobile
        activator={(onOpen) => (
          <BtnWrapper
            onClick={() => (isMobile ? onOpen() : handleClickShow())}
            half={show}
          >
            <BtnCreate>
              <img src={imgAdd} alt="" />
            </BtnCreate>
            <TextXs className="text-black-20%">Creat new project</TextXs>
          </BtnWrapper>
        )}
      /> */}

      <BtnWrapper onClick={handleClickShow} half={show}>
        <BtnCreate>
          <img src={imgAdd} alt="" />
        </BtnCreate>
        <TextXs className="text-black-20%">Creat new project</TextXs>
      </BtnWrapper>

      {show && (
        <div className="bg-white flex-1 flex items-center px-3 gap-2">
          <InputText
            small
            placeholder="프로젝트명을 입력해주세요."
            value={name}
            onChange={(e) => setName(e.target.value)}
            shape="square"
          />
          <Btn.Blue
            onClick={handleCreateProject}
            size="xsSmall"
            className="flex-none !px-2"
            inActive={!name}
          >
            등록
          </Btn.Blue>
        </div>
      )}
    </Container>
  );
};

const Container = styled.li`
  display: flex;
  flex-direction: column;
  height: 168px;
  border: 1px solid ${COLORS.black["20%"]};
  border-radius: 10px;
  overflow: hidden;
  background-color: ${COLORS.white["60%"]};
  cursor: pointer;
`;

const BtnWrapper = styled.div<{ half: boolean }>`
  height: ${({ half }) => (half ? "112px" : "100%")};
  flex: none;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 8px;
`;

const BtnCreate = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 30px;
`;

export default ItemCreate;
